import{
  FETCH_CMS_DATA, CMS_DATA_REQUEST
} from '../constants/cms'

import cms from '../utils/cms/'

export function getCmsData(id) {
  return (dispatch) => {
    dispatch({
      type   : CMS_DATA_REQUEST,
      payload: {
        page: {
          data    : null,
          fetching: true,
        }
      }
    })

    cms.getCmsData(id).then(data => {
      dispatch({
        type   : FETCH_CMS_DATA,
        payload: {
          page: {
          data    : data.content,
          fetching: false,
        }
        }
      })
    });
  }
}

export function getCmsList(category = null) {
  return (dispatch) => {
    dispatch({
      type   : CMS_DATA_REQUEST,
      payload: {
        cmsLinks: {
          fetching: true
        }
      }
    })
    cms.getCmsList(category).then(d => {
      dispatch({
        type   : FETCH_CMS_DATA,
        payload: {
          cmsLinks: {
            data    : d,
            fetching: false
          }
        }
      })
    })
  }
}

export function getCmsListH(category = null) {
  return (dispatch) => {
    dispatch({
      type   : CMS_DATA_REQUEST,
      payload: {
        cmsLinksHeader: {
          fetching: true
        }
      }
    })
    cms.getCmsLists(category).then(d => {
      dispatch({
        type   : FETCH_CMS_DATA,
        payload: {
          cmsLinksHeader: {
            data    : d,
            fetching: false
          }
        }
      })
    })
  }
}


// WEBPACK FOOTER //
// ./src/actions/cmsActions.js